import { TaskpaneApp } from "./taskpane/TaskpaneApp";

export function App() {
  return <TaskpaneApp />;
}
